import { render, staticRenderFns } from "./SimpleBg.vue?vue&type=template&id=3f5c3251&scoped=true&"
import script from "./SimpleBg.vue?vue&type=script&lang=js&"
export * from "./SimpleBg.vue?vue&type=script&lang=js&"
import style0 from "./SimpleBg.vue?vue&type=style&index=0&id=3f5c3251&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5c3251",
  null
  
)

export default component.exports